<template>
    <div class="table-row">
        <div class="title-area">
            <div class="img-box">
                <img :src="require(`@/assets/${src}`)" alt="" />
            </div>
        </div>
        <div class="content-area">
            <p class="title">{{ title }}</p>
            <p v-if="content" v-html="content"></p>
            <ul v-if="list">
                <li v-for="(item, idx) in list" :key="idx" v-html="item"></li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        title: {},
        content: {},
        list: {},
        src: {},
    },
};
</script>
<style lang="scss" scoped>
.table-row {
    padding: 70px 32px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    .title-area {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 30px;

        .img-box {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 70px;
            height: 70px;
        }
    }

    .content-area {
        p.title {
            font-family: 'Pretendard', sans-serif;
            font-weight: 600;
            font-size: 22px;
            letter-spacing: -0.025em;
            color: var(--black1);
            margin-bottom: 30px;
            @media screen and (max-width: 768px) {
                font-size: 20px;
            }
        }

        p {
            font-family: 'Pretendard', sans-serif;
            font-size: 18px;
            color: var(--black2);
            letter-spacing: -0.025em;
            font-weight: 400;
            line-height: 1.6;
            word-break: keep-all;
            color: var(--black3);
            @media screen and (max-width: 768px) {
                font-size: 16px;
            }
        }

        ul li {
            position: relative;
            list-style: none;
            letter-spacing: -0.025em;
            padding-left: 12px;
            color: var(--black3);
            font-weight: 400;
            font-family: 'Pretendard', sans-serif;
            font-size: 18px;
            word-break: keep-all;
            @media screen and (max-width: 768px) {
                font-size: 16px;
            }

            & + li {
                margin-top: 10px;
            }

            &::after {
                position: absolute;
                content: '';
                width: 4px;
                height: 4px;
                background: #ccc;
                top: calc(1ch - 2px);
                left: 0;
            }
        }
    }
}
</style>
